export const ANALYTICS_CONSENT_COOKIE = "ariaflow_analytics_consent";
export const ANALYTICS_CONSENT_VERSION = "v1";
export const ANALYTICS_CONSENT_MAX_AGE = 60 * 60 * 24 * 180;
export const ANALYTICS_CONSENT_CHANGED_EVENT =
  "ariaflow:analytics-consent-changed";

export type AnalyticsConsent = "granted" | "denied";

export const parseAnalyticsConsent = (
  cookieHeader: string,
): AnalyticsConsent | null => {
  const cookie = String(cookieHeader || "")
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${ANALYTICS_CONSENT_COOKIE}=`));
  if (!cookie) return null;

  const value = decodeURIComponent(cookie.slice(cookie.indexOf("=") + 1));
  if (value === `${ANALYTICS_CONSENT_VERSION}.granted`) return "granted";
  if (value === `${ANALYTICS_CONSENT_VERSION}.denied`) return "denied";
  return null;
};

export const serializeAnalyticsConsent = (
  consent: AnalyticsConsent,
  secure = true,
) =>
  [
    `${ANALYTICS_CONSENT_COOKIE}=${ANALYTICS_CONSENT_VERSION}.${consent}`,
    `Max-Age=${ANALYTICS_CONSENT_MAX_AGE}`,
    "Path=/",
    "SameSite=Lax",
    secure ? "Secure" : "",
  ]
    .filter(Boolean)
    .join("; ");

export const hasGrantedAnalyticsConsent = (cookieHeader: string) =>
  parseAnalyticsConsent(cookieHeader) === "granted";

export const persistAnalyticsConsent = (
  consent: AnalyticsConsent,
  secure = true,
) => {
  if (typeof document === "undefined") return;

  document.cookie = serializeAnalyticsConsent(consent, secure);
  window.dispatchEvent(
    new CustomEvent<AnalyticsConsent>(ANALYTICS_CONSENT_CHANGED_EVENT, {
      detail: consent,
    }),
  );
};
